export { default } from './forEach.js'



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/each.js
// module id = 1582
// module chunks = 0